import { motion } from "framer-motion";
import { Instagram, Mail } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { CONTACT } from "@/lib/site";

const FOUNDERS = [
  {
    name: "Vaibhavi",
    role: "Co-Founder & Promoter",
    img: "/assets/vaibhavi.jpg",
    bio: "Drives brand, nutrition and the guest experience \u2014 making sure every MacroDrink is as good for you as it tastes.",
    email: CONTACT.email,
  },
  {
    name: "Varun",
    role: "Co-Founder & Promoter",
    img: "/assets/varun.jpg",
    bio: "Leads operations and the vending technology \u2014 putting a fresh nutrition bar within arm's reach, everywhere.",
    email: CONTACT.email,
  },
];

export default function Founders() {
  return (
    <section id="team" data-testid="founders" className="relative bg-[#D9F4CD] py-24 md:py-40 border-t border-[#17320B]/10">
      <div className="relative z-10 mx-auto max-w-[1400px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
          <Reveal>
            <span className="font-mono-eb text-xs uppercase tracking-[0.3em] text-[#7B9C62]">/ The Promoters</span>
            <h2 className="font-display uppercase text-4xl md:text-6xl lg:text-7xl tracking-tighter leading-[0.9] mt-5 text-[#17320B]">
              Built By <span className="text-[#7B9C62]">People</span><br />Who Train.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-[#17320B]/70 text-base md:text-lg">
              TheMacroBar is founded and run by a small, obsessive team on a mission to make clean
              nutrition instant, honest and everywhere.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 gap-6 md:gap-8">
          {FOUNDERS.map((f, i) => (
            <Reveal key={f.name} delay={i * 0.1}>
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ type: "spring", stiffness: 300, damping: 22 }}
                data-testid={`founder-${f.name.toLowerCase()}`}
                className="group relative overflow-hidden rounded-sm border border-[#17320B]/10"
              >
                <div className="relative aspect-[4/5] overflow-hidden bg-[#C8ECBB]">
                  <img
                    src={f.img}
                    alt={`${f.name} \u2014 ${f.role}`}
                    className="h-full w-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                  <div className="absolute inset-0" style={{ background: "linear-gradient(to top, rgba(23,50,11,0.94), transparent 55%)" }} />
                  <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                    <div className="font-mono-eb text-[10px] uppercase tracking-[0.2em] text-[#C2E9FF] mb-2">{f.role}</div>
                    <h3 className="font-display uppercase text-4xl md:text-5xl tracking-tight leading-none text-white">{f.name}</h3>
                    <p className="text-white/70 text-sm mt-4 max-w-md leading-relaxed">{f.bio}</p>
                    <div className="mt-5 flex items-center gap-3">
                      <a href={`mailto:${f.email}`} aria-label={`Email ${f.name}`} data-testid={`founder-${f.name.toLowerCase()}-email`} className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-white hover:border-[#C2E9FF] hover:text-[#C2E9FF] transition-colors duration-300">
                        <Mail size={16} />
                      </a>
                      <a href="https://instagram.com/the.macro.bar" target="_blank" rel="noreferrer" aria-label="Instagram" className="flex h-10 w-10 items-center justify-center rounded-full border border-white/30 text-white hover:border-[#C2E9FF] hover:text-[#C2E9FF] transition-colors duration-300">
                        <Instagram size={16} />
                      </a>
                    </div>
                  </div>
                </div>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
